
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import { SiteMapData, SiteMapMethods, SiteMapComputed, SiteMapProps } from './SiteMap';
import { componentMode } from './Footer.config';
import OwcFooterSiteMapSection from '@owc-packages/Footer/src/SiteMapSection.vue';

/**
 * `SiteMap Footer` - SiteMap for OneWeb - This component contains the sitemap sections for the footer.
 */

export default ComponentInitializeDispatcher.extend<
  SiteMapData,
  SiteMapMethods,
  SiteMapComputed,
  SiteMapProps
>({
  name: 'owc-site-map',
  components: {
    OwcFooterSiteMapSection,
    SlotContainer,
  },
  props: {
    siteMap: {
      type: Array,
    },
  },
  computed: {
    isEdit: function(): boolean {
      return componentMode.isEditMode;
    },
  },
});
